module.exports = __webpack_public_path__ + "static/media/night_flight_6.3cc342ba.jpg";